module.exports = __webpack_public_path__ + "img/id_ind.e2d94b7f.png";